import type { KeywordResponseFilterValue } from '@hotjar/global-filters';
import type { KeywordFilterDto } from '../filters/FiltersMappings';
import { IncomingFeedbackDtoFilters } from '../filters/FiltersMappings';

export function keywordFilterConverter(
  filterValue: KeywordResponseFilterValue,
): KeywordFilterDto | undefined {
  if (!filterValue) {
    return undefined;
  }

  return {
    type: IncomingFeedbackDtoFilters.KEYWORD,
    value: filterValue.value,
    operation: filterValue.operation,
  };
}
